import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_SMS_PETITION_UPDATES = defineFcm('starter_experience_sms_petition_updates')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		experimentName: 'starter_experience_sms_petition_updates',
		enabled: false,
	})
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-front-end',
		context: 'Post-Start A Petition Phone Collection',
		description:
			'Controls whether the post-SAP phone collection step shows a combined SMS updates and journalist outreach opt-in screen instead of the standalone journalist outreach opt-in.',
		import: false,
		template: {
			experimentName: 'starter_experience_sms_petition_updates',
			enabled: false,
		},
	});
